const AvatarPosition = {
    CENTER: 'avatar-center',
    MIDDLE_LEFT: 'avatar-middle-left',
    MIDDLE_FAR_LEFT: 'avatar-middle-far-left',
    START_MIDDLE_LEFT: 'avatar-start-middle-left',
    LOWER_LEFT: 'avatar-lower-left',
    LOWER_FAR_LEFT: 'avatar-lower-far-left',
    OFFSCREEN: 'avatar-offscreen',
    HIDDEN: 'avatar-hidden',
    TOP_HEADER_CENTER: 'avatar-top-header-center',
    VERTICAL_CENTER: 'avatar-middle-center',
};

export default AvatarPosition;
